export const setSettings = (state, settings) => {
  state.settings = settings;
};

export const setDates = (state, dates) => {
  state.dates = dates;
};
